import { formatAmount } from "@/shared/components/Policy/PolicyAmountRow";

import type { InvoiceLineColumn } from "../types";
import { INVOICE_CURRENCY_SYMBOL } from "./invoice";
import { INVOICE_LOCALISATION } from "./localisation";

export const formatInvoiceMoney = (value: number) =>
  `${INVOICE_CURRENCY_SYMBOL}\u00A0${formatAmount(value)}`;

export const INVOICE_COLUMN_ALIGN_CLASS: Record<
  NonNullable<InvoiceLineColumn["align"]>,
  { cell: string; header: string }
> = {
  left: { cell: "text-left", header: "justify-start" },
  center: { cell: "text-center", header: "justify-center" },
  right: { cell: "text-right", header: "justify-end" },
};

export const INVOICE_LINE_COLUMNS: InvoiceLineColumn[] = [
  {
    key: "policyNo",
    label: "Policy No",
    cellClassName: "font-medium",
    render: (line) => line.policyNo,
  },
  {
    key: "product",
    label: "Product",
    render: (line) => line.product,
  },
  {
    key: "customer",
    label: "Customer",
    cellClassName: "capitalize",
    render: (line) => line.customer,
  },
  {
    key: "premium",
    label: "Premium",
    align: "center",
    render: (line) => formatInvoiceMoney(line.premium),
  },
  {
    key: "rate",
    label: "Rate",
    align: "center",
    render: (line) => `${line.ratePercent.toFixed(1)}%`,
  },
  {
    key: "commission",
    label: "Commission",
    align: "center",
    cellClassName: "font-semibold",
    render: (line) => formatInvoiceMoney(line.commission),
  },
];

export const INVOICE_PREVIEW_COLUMNS: InvoiceLineColumn[] = [
  {
    key: "policyNo",
    label: "Policy No",
    cellClassName: "font-medium",
    render: (line) => line.policyNo,
  },
  {
    key: "customer",
    label: "Customer",
    cellClassName: "capitalize",
    render: (line) => line.customer,
  },
  {
    key: "product",
    label: "Product",
    render: (line) => line.product,
  },
  {
    key: "premium",
    label: "Premium",
    align: "right",
    render: (line) => formatInvoiceMoney(line.premium),
  },
  {
    key: "commission",
    label: "Commission",
    align: "right",
    render: (line) => formatInvoiceMoney(line.commission),
  },
  {
    key: "tax",
    label: INVOICE_LOCALISATION.taxLabel,
    align: "right",
    render: (line) =>
      formatInvoiceMoney((line.commission * INVOICE_LOCALISATION.taxRatePercent) / 100),
  },
];
